import { FormState } from 'final-form'
import { useForm, useFormState } from 'react-final-form'
import React, { useState } from 'react'

export const AutoSaveOnBlur: React.FC = () => {
  const form = useForm()
  const [lastActive, setActive] = useState<string | undefined>('')
  function onChange<T>(formState: FormState<T>) {
    const { active, pristine, valid, submitSucceeded } = formState
    if (valid && !pristine && lastActive !== active && lastActive !== '' && active === undefined && !submitSucceeded) {
      form.submit()
    }
    setActive(active)
  }
  useFormState({ onChange })
  return null
}
